import SessionStorageManager from 'services/SessionStorageManager'
import StorageManager from 'services/StorageManager'
import {
  IS_NEW_ACCOUNT_KEY,
  SHOW_LOGIN_SNACKBAR_KEY,
} from 'services/LoginUtills'
import { isClient } from 'utils/runtimeUtils'

export type LoginNoticeTitleKey =
  | 'login.login_successfully'
  | 'login.register_successfully'

// Module state on purpose: it dies with the document, which is exactly the
// question being asked — is *this* document about to be replaced? The embedded
// login merges the account's books before it reloads, so without this the
// notice fires into a page the user is a moment away from losing.
let isLoginReloadMarked = false

export function markLoginReloadPending(): void {
  isLoginReloadMarked = true
}

export function markLoginReloadAbandoned(): void {
  isLoginReloadMarked = false
}

export function isLoginReloadPending(): boolean {
  return isLoginReloadMarked
}

export function isLoginNoticePending(): boolean {
  return (
    isClient() && Boolean(SessionStorageManager.get(SHOW_LOGIN_SNACKBAR_KEY))
  )
}

export function takeLoginNotice(): LoginNoticeTitleKey | null {
  if (!isLoginNoticePending()) return null
  SessionStorageManager.remove(SHOW_LOGIN_SNACKBAR_KEY)
  return StorageManager.get<boolean>(IS_NEW_ACCOUNT_KEY)
    ? 'login.register_successfully'
    : 'login.login_successfully'
}
